import { CircularProgress } from '@mui/material';

interface ButtonLoadingIndicatorProps {
  size?: number;
}

export function ButtonLoadingIndicator({ size }: ButtonLoadingIndicatorProps) {
  return <CircularProgress sx={{ color: 'progress.circular.primary' }} size={size} />;
}
